import React, { Component, memo } from 'react';
import ReactCodeInput from 'react-code-input';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import Counter from 'Components/Modal/Otp/Counter';

class Otp extends Component {

  static propTypes = {
    otpData: PropTypes.object,
    phone: PropTypes.string,
    email: PropTypes.string,
    errorText: PropTypes.string,
    hasError: PropTypes.bool,
    sendOtpCode: PropTypes.func,
    onChangeOtpCode: PropTypes.func,
    onChangeTimeOver: PropTypes.func,
    code: PropTypes.string,
  };

  constructor (props) {
    super(props);

    this.state = {
      isTimeOver: false,
    };
  }

  onSubmitAgain = () => {
    this.counter.startCounter();
    this.setState({
      isTimeOver: false,
      code: '',
    });
    this.props.onChangeTimeOver(false);
  }

  timeIsOver = () => {
    this.props.onChangeTimeOver(true);
    this.setState({
      isTimeOver: true,
    });
  }

  handleCodeInputChange = value => {
    this.props.onChangeOtpCode(value);
  }

  componentDidUpdate (prevProps, prevState) {
    
    if (this.state.isTimeOver && prevProps.otpData?.activationDate != this.props.otpData?.activationDate) {
      this.onSubmitAgain();
    }
  }

  render () {
    const { errorText, hasError, code } = this.props;
    const errorMessage = errorText && (<div className='error-message'>{ errorText }</div>);
    // hasError: mesajı üst bileşen basıyor (phone-verification__otp-title), burada sadece hata görünümü uygulanır
    const inputClass = classnames({
      'code-input': true,
      'code-input--error': !!errorText || !!hasError
    });
   
    return (
      <div className='otp'>
        <div className='otp__form form otp__transparent'>
          <div className='form__row'>
            { errorMessage }
            <ReactCodeInput
              ref={ c => this.code = c }
              type='number'
              fields={ 6 }
              className={ inputClass }
              inputStyle={ {} }
              inputStyleInvalid={ {} }
              value={ code }
              onChange={ this.handleCodeInputChange }
            />
          </div>
        </div>
        <Counter  showIndicator={ false } duration={ this.props.otpData?.expireTimeInSeconds } ref={ c => this.counter = c } timeIsOver={ this.timeIsOver } />
                 
      </div>
    );
  }
}

export default memo(Otp);
